// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EPefJtCvrW08dv6YYzge{justify-content:space-between;align-items:center;display:flex}.G310wYlntQTHiWDJqm3O{color:var(--content-primary-tertiary)}.gvHlBQvKYAZIxNWTkq2O{width:100%}.bNXb6A8d4kGZkqqu82_g{flex-direction:column;gap:8px;padding:8px 12px;display:flex}.bNXb6A8d4kGZkqqu82_g:hover:not(.Ktokuwrb5ANnLjHOpLxW){cursor:pointer;background:var(--background-neutral-subtle,#f6f7f8);border-radius:6px}.UyiIRqSNrI16HchQkdrh,.i7egYCiTlAhaYKIlMxfw{align-items:center;gap:8px;display:flex}.LHPaog4_MZux5sZ9gZow,.gvAHwpDjwi8g88N23kLq{color:var(--content-primary-tertiary)}.YbEyqSJy2QxkVdueIA5w{background-color:var(--content-primary-disabled);border-radius:50%;width:2px;height:2px}.kLfP62BJ9OsXhjQs4sV7{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `EPefJtCvrW08dv6YYzge`,
	"label": `G310wYlntQTHiWDJqm3O`,
	"dropdown": `gvHlBQvKYAZIxNWTkq2O`,
	"trigger": `bNXb6A8d4kGZkqqu82_g`,
	"notInteractive": `Ktokuwrb5ANnLjHOpLxW`,
	"trigger__item": `UyiIRqSNrI16HchQkdrh`,
	"triggerItem": `UyiIRqSNrI16HchQkdrh`,
	"trigger__row": `i7egYCiTlAhaYKIlMxfw`,
	"triggerRow": `i7egYCiTlAhaYKIlMxfw`,
	"trigger__icon": `LHPaog4_MZux5sZ9gZow`,
	"triggerIcon": `LHPaog4_MZux5sZ9gZow`,
	"trigger__text": `gvAHwpDjwi8g88N23kLq`,
	"triggerText": `gvAHwpDjwi8g88N23kLq`,
	"trigger__dot": `YbEyqSJy2QxkVdueIA5w`,
	"triggerDot": `YbEyqSJy2QxkVdueIA5w`,
	"trigger__number": `kLfP62BJ9OsXhjQs4sV7`,
	"triggerNumber": `kLfP62BJ9OsXhjQs4sV7`
};
export default ___CSS_LOADER_EXPORT___;
